<div class="scrollable-section">
	@if (isLoading) {
		<div class="loading-overlay">
			<img class="spinner" src="./assets/spinner2.gif" style="opacity: 0; transition: opacity 0.2s" />
		</div>
	}
	<div class="flex align-center">
		<h2 class="mat-heading flex-1">{{ 'masterdata.cutting.configs.label' | translate }}</h2>
		<div class="flex gap-8">
			<header-sub-menu [favoriteItems]="favoriteItems" [menuItems]="menuItems"></header-sub-menu>
			<button class="gap-16" mat-flat-button color="secondary" [disabled]="isLoading" (click)="resetConfiguration()">
				{{ 'masterdata.common.resetAllChanges' | translate }}
				<mat-icon svgIcon="acies_reset"></mat-icon>
			</button>
			<button class="gap-16" mat-flat-button color="primary" [disabled]="isLoading || !currentConfig || extraRodsFormControl.invalid" (click)="saveConfiguration()">
				{{ 'masterdata.common.saveAllChanges' | translate }}
				<mat-icon svgIcon="acies_save"></mat-icon>
			</button>
		</div>
	</div>
	<table class="table-responsive" mat-table recycleRows [dataSource]="configSource" matSort>
		<ng-container matColumnDef="allowFrameAndSashInSameBasket">
			<th mat-header-cell *matHeaderCellDef class="centered-content">
				{{ 'masterdata.cutting.configs.allowFrameAndSashInSameBasket' | translate }}
			</th>
			<td mat-cell *matCellDef="let element" style="text-align: center">
				<mat-checkbox disabled="{{ !extraRodsFormValid }}" [(ngModel)]="element.allowFrameAndSashInSameBasket" (ngModelChange)="updateConfig(element)" aria-label="Toggle frame and sash in same basket"></mat-checkbox>
			</td>
		</ng-container>

		<ng-container matColumnDef="allowMixedCrossSectionInSameBasket">
			<th mat-header-cell *matHeaderCellDef class="centered-content">
				{{ 'masterdata.cutting.configs.allowMixedCrossSectionInSameBasket' | translate }}
			</th>
			<td mat-cell *matCellDef="let element" style="text-align: center">
				<mat-checkbox disabled="{{ !extraRodsFormValid }}" [(ngModel)]="element.allowMixedCrossSectionInSameBasket" (ngModelChange)="updateConfig(element)" aria-label="Toggle mixed section in same basket"></mat-checkbox>
			</td>
		</ng-container>

		@if (showGenerateRodsForWaste) {
			<ng-container matColumnDef="generateRodsForWaste">
				<th mat-header-cell *matHeaderCellDef class="centered-content">
					{{ 'masterdata.cutting.configs.generateRodsForWaste' | translate }}
				</th>
				<td mat-cell *matCellDef="let element" style="text-align: center">
					<mat-checkbox disabled="{{ !extraRodsFormValid }}" [(ngModel)]="element.generateRodsForWaste" (ngModelChange)="updateConfig(element)" aria-label="Toggle generate rods for waste"></mat-checkbox>
				</td>
			</ng-container>
		}

		<ng-container matColumnDef="extraRodsPercentage">
			<th mat-header-cell *matHeaderCellDef class="centered-content">
				{{ 'masterdata.cutting.configs.extraRodsPercentage' | translate }}
			</th>
			<td mat-cell *matCellDef="let element" style="text-align: center">
				<mat-form-field appearance="outline" style="padding-top: 18px">
					<input matInput [formControl]="extraRodsFormControl" [(ngModel)]="element.extraRodsPercentage" (change)="updateConfig(element)" min="0" max="100" type="number" />
					<mat-error>
						{{ 'masterdata.cutting.dialog.extraRodsPercentage.errors.invalid' | translate }}
					</mat-error>
				</mat-form-field>
			</td>
		</ng-container>

		<tr mat-header-row *matHeaderRowDef="configsTableColumns; sticky: true"></tr>
		<tr mat-row *matRowDef="let row; columns: configsTableColumns"></tr>
	</table>

	<div class="table-spacing"></div>

	<h2 class="table-header">{{ 'masterdata.cutting.machines.machines' | translate }}</h2>
	<app-generictable
		[showPaginator]="showPaginator"
		[tableSource]="machinesSource"
		[hasSelectColumn]="false"
		[tableColumns]="machinesTableColumns"
		[showFirstLastButtons]="false"
		[filterWord]="configsFilter"
		[rowActions]="regRowActions"
		(menuEmitter)="handleRowMenuActionMachines($event)"
		(paginatorEmitter)="handleReloadData($event)"
		[totalRowCount]="machinesSource.data.length"></app-generictable>

	<div class="table-spacing"></div>

	<h2 class="table-header">{{ 'masterdata.cutting.colors.colors' | translate }}</h2>
	<app-generictable
		[showPaginator]="showPaginator"
		[tableSource]="colorsSource"
		[hasSelectColumn]="false"
		[tableColumns]="colorsTableColumns"
		[showFirstLastButtons]="false"
		[filterWord]="configsFilter"
		[rowActions]="regRowActions"
		(menuEmitter)="handleRowMenuActionColors($event)"
		(paginatorEmitter)="handleReloadData($event)"
		[totalRowCount]="colorsSource.data.length"></app-generictable>
</div>
